import React, { useState } from 'react';
import { DropdownMenu } from '@spark';

const LANGUAGE_LABELS = {
    python: 'Python',
    typescript: 'TypeScript',
    go: 'Go',
};

/**
 * Reusable language selector component for choosing between Python, TypeScript, and Go.
 * @param {Object} props
 * @param {string} props.selectedLanguage - Currently selected language
 * @param {function} props.onLanguageChange - Callback when language is changed
 * @param {Array<string>} [props.languages] - Array of language options (default: ['python', 'typescript', 'go'])
 */
const LanguageSelector = ({ selectedLanguage, onLanguageChange, languages = ['python', 'typescript', 'go'] }) => {
    const [open, setOpen] = useState(false);
    const items = languages.map((lang) => ({
        label: LANGUAGE_LABELS[lang] || lang,
    }));

    const handleSelect = (item) => {
        const lang = languages.find((l) => (LANGUAGE_LABELS[l] || l) === item.label);
        if (lang) onLanguageChange(lang);
        setOpen(false);
    };

    return (
        <DropdownMenu
            size="small"
            showLabel={false}
            items={items}
            value={LANGUAGE_LABELS[selectedLanguage] || selectedLanguage}
            text={LANGUAGE_LABELS[selectedLanguage] || selectedLanguage}
            open={open}
            onOpenChange={setOpen}
            onSelect={handleSelect}
            className="docs-language-selector"
            panelClassName="docs-code-selector-panel"
        />
    );
};

export default LanguageSelector;
